import { render, staticRenderFns } from "./SolicitudesCesion.vue?vue&type=template&id=5ffabeae&scoped=true"
import script from "./SolicitudesCesion.vue?vue&type=script&lang=js"
export * from "./SolicitudesCesion.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesCesion.vue?vue&type=style&index=0&id=5ffabeae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffabeae",
  null
  
)

export default component.exports